<SidebarShell
  :logo="bolide_short_logo"
  brand_title="Empire Partner Foundation"
  brand_subtitle="Department of Water and Sanitation"
  :initials="initials"
  :full_name="full_name"
>
  <!-- HEADER ACTIONS -->
  <template #sidebar-header-actions>
    <slot name="sidebar-header-actions" />
  </template>

  <!-- CONTEXT -->
  <template #context>
    <SidebarContext
      :main_label="active_property?.title"
      :sub_label="active_property?.description"
      :items="propertiesFormatted"
      :active_id="active_property?.id"
      :open="dropdownOpen"
      @toggle="toggleDropdown"
      @select="switchProperty"
    >
      <template #top>
        <div
          class="border-bottom border-secondary pb-2 mb-2 cursor-pointer"
          @click="backToGlobal"
        >
          <p class="text-white fw-light text-xs mb-2">
            {{ entity_name }}
          </p>
          <p class="text-white-50 fw-light text-xxs mb-0">
            {{ entity_subtitle }}
          </p>
        </div>
      </template>
    </SidebarContext>
  </template>

  <!-- MENU -->
  <template #menu>
    <div class="px-3 mt-3 w-100">

      <!-- DYNAMIC MENU ITEMS -->
      <div
        v-for="item in menuItems"
        :key="item.key"
        class="d-flex align-items-center py-2 ps-2
              rounded
              w-100
              transition-all
              sidebar-menu-clickable"
        :class="[
          active_menu_item === item.key
            ? 'bg-dark text-white border-start border-3 border-primary'
            : 'text-white-50 hover-bg-dark'
        ]"
        @click="selectPropertyMenuItem(item.key)"
      >

        <!-- CUSTOM LOGO -->
        <template v-if="item.icon === 'custom'">
          <img
            :src="item.logo"
            alt="Menu Logo"
            class="me-2 sidebar-logo-icon"
          />
        </template>

        <!-- NORMAL ICON -->
        <template v-else>
          <i
            :class="[
              item.icon,
              'me-2',
              active_menu_item === item.key ? 'text-white' : 'text-white-50'
            ]"
          ></i>
        </template>

        <!-- LABEL -->
        <p class="sidebar-menu-text fw-semibold text-xs mb-0">
          {{ item.label }}
        </p>

      </div>

    </div>
  </template>

  <!-- ✅ AFTER MENU (NOW LEGAL) -->
  <template #after-menu>
    <div class="px-3 mt-4">
      <hr class="border-secondary opacity-50 mb-2" />

      <p class="text-white-50 text-xxs mb-2">
        AUTOMATION (Future)
      </p>

      <div class="d-flex align-items-center justify-content-between ps-3 mb-2 not-clickable">
        <div class="d-flex align-items-center">
          <i class="bi bi-arrow-return-right text-white-50 me-2"></i>
          <p class="text-white-50 text-xs mb-0">
            Voice Dial &amp; Tasks
          </p>
        </div>

        <span class="badge bg-warning text-dark fw-bold rounded-pill px-2 py-1 text-xxs">
          BETA
        </span>
      </div>
    </div>
  </template>

</SidebarShell>
